// extracted by mini-css-extract-plugin
export default {"pageContainer":"PageWithTopbar_pageContainer__RZ8GK","mainContainer":"PageWithTopbar_mainContainer__KDk4J"};